import { shallowRef, ref } from 'vue'
import { useTemplate } from '../../../hooks/index'
import { setValueByPathToVue, setValueByPath } from '../../../utils/index'
/**
 * 查询表单处理
 * @param {查询条件是否设置默认事件（如光标在输入框时点击回车触发查询等）} queryFormEvent
 * @returns
 */
export function useCriteriaQuery(queryFormEvent = false) {
  const { getTemplateData, compileData } = useTemplate()
  const shortcutForm = shallowRef(null)
  const shortcutData = ref({})
  const queryForm = shallowRef(null)
  const queryData = ref({})
  //当key存在时修改queryData对应key的值为data，key不存在时修改queryData为data
  const updateQueryData = (key, data) => {
    if (key) {
      queryData.value[key] = data
    } else {
      queryData.value = data
    }
  }
  //根据传入对象重新设置queryData和shortcutData; 优先设置快捷查询的值，剩余属性一并赋值给queryData
  const updateQueryAndShortcutData = (data) => {
    shortcutData.value = shortcutForm.value.items.reduce((pre, cur) => {
      // #38210, 浏览器版本过低会报错 Object.hasOwn(data, cur.property)
      if (data.hasOwnProperty(cur.property)) {
        setValueByPath(pre, cur.property, data[cur.property])
        delete data[cur.property]
      }
      return pre
    }, {})
    queryData.value = data
  }
  //设置默认值
  const setDefaultQuery = () => {
    const templateData = getTemplateData()
    shortcutData.value = shortcutForm.value.items.reduce((pre, cur) => {
      if (cur.defaultValue) {
        setValueByPath(pre, cur.property, compileData(cur.defaultValue, templateData))
      }
      return pre
    }, {})
    queryData.value = queryForm.value.items.reduce((pre, cur) => {
      if (cur.defaultValue) {
        setValueByPath(pre, cur.property, compileData(cur.defaultValue, templateData))
      }
      return pre
    }, {})
  }
  const setQueryForm = (resData, searchData, shortcut = true) => {
    if (shortcut) {
      //增加查询事件（当值改变时触发查询）
      const setEvent = (componentCode, property) => {
        const query = (val) => {
          setValueByPathToVue(shortcutData.value, property, val)
          searchData()
        }
        if (
          [
            'input',
            'i-input',
            'inputNumber',
            'panguInputNumber',
            'PgInput',
            'PgInputNumber',
          ].indexOf(componentCode) !== -1
        ) {
          return {
            enter: searchData,
            'on-enter': searchData,
            clear: query,
            'on-clear': query,
          }
        } else if (['PgDatePickerRange'].indexOf(componentCode) !== -1) {
          return {
            'on-change': query,
          }
        } else {
          return {
            change: query,
            'on-change': query,
          }
        }
      }
      shortcutForm.value = {
        code: resData.criteria?.code,
        id: resData.criteria?.id,
        form: {
          property: {
            formGroup: false,
          },
        },
        items: resData.items.filter((im) => {
          if (im.shortcut) {
            im.label = null
            if (!im.parameter) im.parameter = {}
            im.parameter.event = setEvent(im.component?.code, im.property)
          }
          return im.shortcut
        }),
      }
    }
    queryForm.value = {
      code: resData.criteria?.code,
      id: resData.criteria?.id,
      form: {
        property: {
          formGroup: false,
          inline: false,
        },
      },
      items: resData.items.filter((im) => {
        if (!im.shortcut) {
          if (!im.parameter) im.parameter = {}
          if (
            queryFormEvent &&
            [
              'input',
              'i-input',
              'inputNumber',
              'panguInputNumber',
              'el-input',
              'ElInput',
              'PgInputNumber',
            ].indexOf(im.component?.code) !== -1
          ) {
            im.parameter.event = {
              enter: searchData,
              'on-enter': searchData,
            }
          }
        }
        return !im.shortcut
      }),
    }
  }

  return {
    shortcutForm,
    shortcutData,
    queryForm,
    queryData,
    updateQueryData,
    setQueryForm,
    setDefaultQuery,
    updateQueryAndShortcutData,
  }
}
